/**
 * historiasApi — cliente del CRUD de historias del backend de tadmin.
 *
 * Recibe el token de Clerk como primer parametro, igual que
 * src/services/yoolpay/conciliacionApi.js. En dev el `proxy` de package.json
 * ("http://localhost:3011") hace que la ruta relativa llegue al Express
 * (backend/routes/historias.js). En Vercel no hay Express: la ruta relativa
 * la sirven las funciones serverless `api/historias/index.js` y
 * `api/historias/[id].js` (mismo origen, por eso tampoco ahi hay base URL) —
 * `vercel.json` excluye `/api/*` del rewrite al SPA, asi que ambos gemelos
 * tienen que existir para que esto funcione desplegado (I5, task-4-review.md).
 *
 * OJO: los servicios vecinos (rendicionService.js, calculatorSimService.js)
 * caen a `http://localhost:3010` como backend local, pero el Express escucha
 * en 3011 (backend/server.js:83 y ecosystem.config.cjs). No copiar ese 3010.
 */
const BASE = '/api/historias';

async function call(path, token, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 204) return null;
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) {
    const motivos = Array.isArray(payload?.motivos) ? `: ${payload.motivos.join('; ')}` : '';
    throw new Error(`${payload?.error || `El backend respondió ${res.status}`}${motivos}`);
  }
  return payload;
}

export const listar = (token) => call('', token);
export const obtener = (token, id) => call(`/${id}`, token);
export const crear = (token, entrada) => call('', token, { method: 'POST', body: entrada });
export const actualizar = (token, id, entrada) =>
  call(`/${id}`, token, { method: 'PUT', body: entrada });
export const eliminar = (token, id) => call(`/${id}`, token, { method: 'DELETE' });
